import * as actionTypes from '../actions/actionTypes';

export const fetchProducts = (data) => {
    return {
        type: actionTypes.FETCH_PRODUCTS,
        products: data
    }
}
export const createProduct = (data) => {
    return {
        type: actionTypes.CREATE_PRODUCT,
        product: data
    }
}
export const deleteProduct = (id) => {
    return {
        type: actionTypes.DELETE_PRODUCT,
        id
    }
}
export const updateProduct = (data) => {
    return {
        type: actionTypes.UPDATE_PRODUCT,
        data
    }
}